import * as React from 'react';
import { observer } from 'mobx-react';
import { T } from '../../../../../Translations';
import SharedRowColumns from '../SharedRowColumns';
import { ParticipantImportFileRow } from '../../Store/Types';

interface Props {
  participant: ParticipantImportFileRow;
}

const Row: React.FC<Props> = ({ participant }) => (
  <tr>
    <SharedRowColumns
      firstname={participant.firstname}
      lastname={participant.lastname}
      email={participant.email}
    />
    <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500">
      <T kind="unconfirmed" />
    </td>
  </tr>
);

export default observer(Row);
